// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
[data-v-f49cd22e] .target-div {
  width: 100%;
}
@media (min-width: 768px) {
.parent[data-v-f49cd22e] .target-div {
    margin: 0 1rem;
    width: calc(100% - 2rem);
}
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
